export class TransferRequestExcelDto {
    StoreOrigin: string;
    StoreDestiny: string;
    StoreOriginCode: string;
    StoreDestinyCode: string;
    StyleVariety: string;
    Season: string;
    Size: string;
    SizeName : string;
    SizeGroupDetCode: string;
    Comment: string;
    Sector: string;
    SectorAuxiliary: string;
    Quantity: number;
    OrganizationId: string;
}
